export { renderColorPicker_unstable as renderColorPicker } from '@fluentui/react-color-picker';
